import { useState } from "react";
import PageContainer from "src/components/container/PageContainer";
import { FormPayeer } from "./FormPayeer";
import { Box, Tabs, Tab } from "@mui/material";
import { FormCrypto } from "./FormCrypto";

const { REACT_APP_NAME } = process.env;

export const TopUpBalance = () => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <>
            <PageContainer
                title={`${REACT_APP_NAME} | Пополнить баланс`}
                description="Пополнить баланс аккаунта"
            >
                <Box sx={{ my: 5 }}>
                    <Tabs
                        value={activeTab}
                        onChange={handleTabChange}
                        sx={{ mb: 3 }}
                    >
                        <Tab label="Криптовалюта" />
                    </Tabs>

                    {activeTab === 0 && <FormCrypto />}
                </Box>
            </PageContainer>
        </>
    );
};